import localStyles from './styles.module.scss';
import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {useAppData} from "../../context/Contexts";
import {useLocalStorage} from "../../hooks/useLocalStorage";

const BonusSection: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [source, setSource] = useLocalStorage("source", "");

    useEffect(() => {
        if (source == 'fb1') {
            setCurrentAppData(prevState => {
                return {...prevState, with_bonus: true}
            })
        }
    }, [source]);

    function onChange() {
        setCurrentAppData(prevState => {
            return {...prevState, with_bonus: !prevState?.with_bonus}
        })
    }

    //console.log('source=', source);

    return (
        <div className={`free_bonus ${localStyles.bonus_section}`}>
            <label htmlFor={`bonus_entry`}>
                <div className={`${localStyles.bonus}`}>BONUS 👉</div>

                <div className="form_control">
                    <input type="checkbox" onChange={onChange} name="bonus_entry"
                           value="" id={`bonus_entry`} checked={currentAppData?.with_bonus}/>
                </div>

                <div className={`${localStyles.title}`}><strong>Get a Free Steering Wheel Cover</strong>Offer ends
                    tonight
                </div>

                <div className={`${localStyles.bonus_img}`}>
                    <span></span>
                    <img
                        src="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/steeringwheel.png?v=175197642654814194691726680148"
                        width="85" alt=""/>
                </div>

            </label>
        </div>
    );
};

export default BonusSection;